import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React from 'react';
import {useSelector} from 'react-redux';
import {Redirect, Route, Switch} from 'react-router-dom';
import Loading from 'Shared/components/Loading';
import {Scope} from 'Shared/constants/Scope';
import ETLDashboard from 'SystemAdministration/components/ETLDashboard';
import {selectUserScopesEither} from 'Users/selectors/userProfileSelectors';

const ROOT_URI = '/systemAdministration';
export const SystemAdministrationRouteConstants = {
  ETL_DASHBOARD: ROOT_URI,
};

const SystemAdministrationRoutes = () => {
  const currentScopesEither = useSelector(selectUserScopesEither);

  const renderSystemAdministrationRoutes = (currentScopes: Scope[]) => {
    const canAccessSystemAdministration = currentScopes.includes(Scope.ReadETLDashboard);

    return canAccessSystemAdministration ? (
      <Route
        render={({match}) => (
          <Switch>
            <Route exact path={SystemAdministrationRouteConstants.ETL_DASHBOARD} render={() => <ETLDashboard />} />
          </Switch>
        )}
      />
    ) : (
      <Redirect to={'/unauthorized'} />
    );
  };

  return (
    <Route
      path={ROOT_URI}
      render={() =>
        pipe(
          currentScopesEither,
          E.fold(() => <Loading />, renderSystemAdministrationRoutes)
        )
      }
    />
  );
};

export default SystemAdministrationRoutes;
